/**
 * ThemeProvider — duenner Wrapper um next-themes.
 *
 * Konvention:
 * - attribute="class" → setzt `class="dark"` auf <html>.
 * - defaultTheme="system" → User-Praeferenz aus OS, mit Override-Möglichkeit.
 * - enableSystem → "System" als gültige Option neben Light/Dark.
 * - disableTransitionOnChange → kein Color-Flicker beim Toggle.
 *
 * Usage:
 *   import { useTheme } from "next-themes";
 *   const { theme, setTheme, resolvedTheme } = useTheme();
 *   setTheme("light" | "dark" | "system");
 *
 * Legacy-Adapter: src/stores/theme.ts spiegelt next-themes als Zustand-Store
 * für Komponenten, die den alten useThemeStore-Hook noch verwenden.
 */
import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from "next-themes";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      storageKey="paypilot.theme"
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
